import { Button } from "@/components/Button";
import Layout from "@/components/Layout";
import LivlySwitch from "@/components/LivlySwitch";
import useLivlyGuest from "@/context/GuestProvider";
import { ServiceTypeEnum } from "@/types/Building";
import { useLocation, useNavigate } from "react-router";

// Service Types to be excluded from additional features
const excludedServiceTypes = [ServiceTypeEnum.LivlyLocks];

const getServiceDescriptionTrans = (type: ServiceTypeEnum) => {
  switch (type) {
    case ServiceTypeEnum.Rent:
      return "View and pay your rent.";
    case ServiceTypeEnum.RentersInsurance:
      return "View and pay your renters insurance.";
    case ServiceTypeEnum.Maintenance:
      return "Create maintenance tickets on your behalf.";
    case ServiceTypeEnum.Utility:
      return "View and setup building utilities.";
    case ServiceTypeEnum.Amenities:
      return "View and book building amenities.";
    case ServiceTypeEnum.Packages:
      return "View your packages and mark as picked up.";
    case ServiceTypeEnum.CommFeed:
      return "View and post to the community feed.";
    case ServiceTypeEnum.Messaging:
      return "View and create conversations.";
    case ServiceTypeEnum.InfoDesk:
      return "View important building information.";
    case ServiceTypeEnum.MarketPlace:
      return "View and purchase services and building offers";
    default:
      return "";
  }
};

export const LivlyFeaturePermission = () => {
  const { skipped = false } =
    (useLocation().state as {
      skipped: false;
    }) || {};

  const { updateGuest, guest } = useLivlyGuest();
  const navigate = useNavigate();

  const onUpdateService = (serviceType: number, enabled: boolean) => {
    const serviceTypes = guest.serviceTypes?.map((service) => {
      if (service?.serviceType === serviceType) {
        return { ...service, enabled };
      }
      return service;
    });

    updateGuest({ ...guest, serviceTypes: serviceTypes });
  };

  const handleNext = () => {
    navigate("../review");
  };

  return (
    <Layout
      back={{
        to: skipped ? "../permission" : "../livly-key-permission",
        label: skipped ? "Access permission" : "Livly Key permission",
      }}
      title="Features permission"
    >
      <div className="max-w-3xl mx-auto">
        <div>
          <p className="text-xl font-medium">Additional features</p>

          <div>
            {guest?.serviceTypes &&
              guest?.serviceTypes?.length > 0 &&
              guest?.serviceTypes
                ?.filter((s) => !excludedServiceTypes.includes(s!.serviceType))
                .map((service) => (
                  <div
                    className="my-4 pb-4 border-b border-gray-300"
                    key={service?.serviceType}
                  >
                    <div className="flex w-full justify-between">
                      <p className="text-lg">{service?.name}</p>
                      <label className="flex flex-col items-end">
                        <LivlySwitch
                          checked={service?.enabled ?? false}
                          onChange={(checked: boolean) =>
                            onUpdateService(service?.serviceType!, checked)
                          }
                        />
                      </label>
                    </div>
                    <div>
                      <p className="text-gray-500 font-normal">
                        {getServiceDescriptionTrans(service?.serviceType!)}
                      </p>
                    </div>
                  </div>
                ))}
          </div>
          <div className="flex justify-end gap-2 mt-8">
            <Button
              size="small"
              color="primary"
              onClick={handleNext}
              className="flex items-center gap-2"
            >
              Next
            </Button>
          </div>
        </div>
      </div>
    </Layout>
  );
};
